import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import KnackLogo from "../../assets/images/knackLogoMenu.png";
import imgCubes from "../../assets/images/cubes_menu.png";
import { useDispatch } from "react-redux";
import { Menu } from "antd";
import "./layout.css";
import {
  setTableSearchInput,
  setTableSortingData,
} from "../../actions/tableListing/tableSortingActionData";
import { useSelector } from "react-redux";
import {
  setGlobalFiltersIds,
  setGlobalFiltersSapCode,
} from "../../actions/globalFilter/globalFilterAction";
import { GetDecryptToken } from "../../helper/http-common";
import activityLogService from "../../services/ActivityLog/activity-log-service";

const { SubMenu } = Menu;

const Sidemenu = ({ collapsed, toggleMobileMenuCollapsed }) => {
  const dispatch = useDispatch();
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  const userApps = useSelector(
    (state) => state.loginReducer.loginDetials.userApplications
  );

  //// resize code in useEffect
  useEffect(() => {
    const handleResize = () => {
      setIsMobileDevice(window.innerWidth <= 1025);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //// handle menu click code
  const handleMenuClick = () => {
    if (isMobileDevice) {
      toggleMobileMenuCollapsed();
    }
  };
  //// handle table column sorting and pagination code
  const handleTableSortingData = () => {
    dispatch(setTableSearchInput(""));
    dispatch(setGlobalFiltersIds(null));
    dispatch(setGlobalFiltersSapCode(null));
    dispatch(
      setTableSortingData({
        sortColumn: "customer_PO_Date", /// default sort column
        orderBy: "desc",
        currentPage: 1,
      })
    );
  };
  /// handle Set nul search data
  const handleSetSearchNullData = () => {
    dispatch(setTableSearchInput(""));
    dispatch(setGlobalFiltersIds(null));
    dispatch(setGlobalFiltersSapCode(null));
  };

  //// handle Activity Log API call for menu items
  const handleActivityLog = (feature, application) => {
    const activityLogPayload = {
      featureName: feature.fT_Name,
      applicationName: application.aP_Name,
    };
    activityLogService.addActivityLogsAPI(activityLogPayload).catch((error) => {
      console.log(error, "Activity Log API Error");
    });
  };

  return (
    <nav className="sidenav__section">
      <button
        className="sidebar__close"
        onClick={() => toggleMobileMenuCollapsed()}
      >
        x
      </button>
      <Link to="/galaxyHome" className="logo_section" onClick={handleMenuClick}>
        <img src={KnackLogo} className="w-30" alt="Galaxy Logo" />
        <span className="px-1 logoTitle">Galaxy Portal</span>
      </Link>
      <div className="menu-content mt-3">
        <Menu
          mode="inline"
          theme="dark"
          inlineCollapsed={collapsed}
          className="menu-items side_menu"
          onClick={handleMenuClick}
        >
          {userApps?.length > 0 &&
            userApps?.map((menu) => (
              <SubMenu
                key={menu.aP_Id}
                icon={
                  <img
                    src={imgCubes}
                    alt={`${menu.aP_Name} Icon`}
                    className="menu-icon"
                  />
                }
                title={<span>{menu.aP_Name}</span>}
              >
                {menu.features.map((feature) => (
                  <Menu.Item key={feature.fT_Id}>
                    <Link
                      to={
                        feature.fT_Name
                          .toLowerCase()
                          .includes("knack design") ||
                        feature.fT_Name.toLowerCase().includes("hrms")
                          ? "/galaxyHome"
                          : `${
                              feature.fT_Name.toLowerCase().includes("o2w")
                                ? "/dashboard/all"
                                : feature.fT_Name
                                    .toLowerCase()
                                    .includes("payment")
                                ? "/payment/customer"
                                : feature.fT_Name
                                    .toLowerCase()
                                    .includes("logistics")
                                ? "/logistic/all"
                                : feature.fT_Name
                                    .toLowerCase()
                                    .includes("visitor")
                                ? "/visitorHome"
                                : feature.fT_Name
                                    .toLowerCase()
                                    .includes("factory")
                                ? "/factory/ReceptionReport"
                                : feature.fT_Name
                                    .toLowerCase()
                                    .includes("office")
                                ? "/office/VisitorReport"
                                : feature.fT_Name
                                    .toLowerCase()
                                    .includes("knack design")
                                ? "/galaxyHome"
                                : feature.fT_Name
                                    .toLowerCase()
                                    .includes("design")
                                ? "/MIS/design"
                                : feature.fT_Name
                                    .toLowerCase()
                                    .includes("sales")
                                ? "/MIS/sales"
                                : feature.fT_Name
                                    .toLowerCase()
                                    .includes("audit")
                                ? "/MIS/auditTraining"
                                : feature.fT_Name
                                    .toLowerCase()
                                    .includes("insurance")
                                ? "/MIS/insurance"
                                : feature.fT_Name
                                    .toLowerCase()
                                    .includes("dispatch")
                                ? "/MIS/dispatch"
                                : feature.fT_Name.toLowerCase().includes("ppc")
                                ? "/MIS/ppc-1"
                                : feature.fT_Name
                                    .toLowerCase()
                                    .includes("purchase")
                                ? "/MIS/purchase"
                                : feature.fT_Name
                                    .toLowerCase()
                                    .includes("looms")
                                ? "/MIS/looms"
                                : feature.fT_Name.toLowerCase().includes("tape",)
                                ? "/MIS/tape"
                                : feature.fT_Name.toLowerCase().includes("itc-4",)
                                ? "/MIS/itc-4"
                                : feature.fT_Name.toLowerCase().includes("lead")
                                ? "/MIS/leadEnquiry"
                                : feature.fT_Name
                                    .toLowerCase()
                                    .includes("recruitment")
                                ? "/MIS/recruitment"
                                : feature.fT_Name
                                    .toLowerCase()
                                    .includes("attendance")
                                ? "/MIS/attendance"
                                : feature.fT_Name
                                    .toLowerCase()
                                    .replace(/ /g, "-")
                            }`
                      }
                      onClick={
                        feature.fT_Name
                          .toLowerCase()
                          .includes("knack design") ||
                        feature.fT_Name.toLowerCase().includes("hrms")
                          ? () => {
                              handleActivityLog(feature, menu);
                              const token = GetDecryptToken();
                              const redirectUrl = feature.fT_Name
                                .toLowerCase()
                                .includes("knack design")
                                ? `${
                                    process.env.REACT_APP_DESIGN_URL
                                  }?token=${encodeURIComponent(token)}`
                                : `${
                                    process.env.REACT_APP_HRMS_URL
                                  }?token=${encodeURIComponent(token)}`;
                              window.open(redirectUrl, "_blank");
                            }
                          : feature.fT_Name.includes("Order")
                          ? () => {
                              handleActivityLog(feature, menu);
                              handleTableSortingData();
                            }
                          : () => {
                              handleActivityLog(feature, menu);
                              handleSetSearchNullData();
                            }
                      }
                    >
                      {feature.fT_Name.includes("O2W")
                        ? "Order to Warehouse"
                        : feature.fT_Name}
                    </Link>
                  </Menu.Item>
                ))}
              </SubMenu>
            ))}
        </Menu>
      </div>
    </nav>
  );
};

export default Sidemenu;
